import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Services
import { ServiceBase } from '../service-base';

// Modèles
import { TaxDetail } from 'src/app/@shared/models/core/taxDetail.model';

// Enums
import { TaxDetailHolderEnum } from 'src/app/@shared/enums/tax-detail-holder.enum';

const CLASS_NAME = 'TaxDetail';
const ENDPOINT = `/tax-details/`;

@Injectable({
    providedIn: 'root'
})
export class TaxDetailsService extends ServiceBase {

    // Pas de cache : comme les taxes, le back borne la liste au pays du dossier. Un cache
    // clé par URL resservirait les motifs du dossier précédent (#173).
    //
    // La liste est filtrée côté serveur par le paramètre `holder` — la répartition des
    // motifs entre le tiers, le bien et le cas d'espèce est une lecture fiscale propre à
    // chaque administration, elle n'a pas à être recopiée ici (#1089).

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }

    /**
     * Motifs qu'un **paramétrage** donné peut porter — fiche tiers ou groupe de
     * marchandises.
     *
     * Sans `holder`, l'endpoint rend les onze motifs : c'est la liste d'une **ligne** de
     * document, qui doit accueillir les cas d'espèce. Ne pas confondre les deux.
     *
     * Le paramètre est posé dans l'URL plutôt que par les options OData : ce n'est pas un
     * filtre de requête, c'est un mode de l'endpoint. ⚠️ Il occupe donc la place du `?`,
     * d'où l'absence de tout autre option ici — un `sorters` s'y ajouterait avec un second
     * `?`. Le tri se fait à l'arrivée.
     */
    public getByHolder$(holder: TaxDetailHolderEnum): Observable<TaxDetail[]> {
        return this.getList$({ url: `${this.routes.list}?holder=${holder}` });
    }
}
